export enum AnswerType {
  Image = 'Image',
  Open = 'Open',
  Regular = 'Regular',
}
